"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReport = void 0;
const fp = require("fp-ts");
const redux_observable_1 = require("redux-observable");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const Actions = require("../../actions/reports");
const ActionTypes = require("../../actionTypes/reports/create");
const Types = require("../../types");
const errorHandling_1 = require("../../utils/errorHandling");
const ValidationUtils = require("../../utils/validation");
const validation_1 = require("./utils/validation");
const validate = (payload) => {
    const validation = ValidationUtils.successValidation;
    if (payload.type !== Types.TEMPLATE) {
        return validation;
    }
    return fp.function.flow((0, validation_1.validateNameNotEmpty)(payload), (0, validation_1.validateNameLength)(payload), (0, validation_1.validateDescriptionLength)(payload))(validation);
};
const getPath = (type) => {
    if (type === Types.TEMPLATE) {
        return '/templates';
    }
    return '/';
};
const createReport = (action$, _store, { ajax, getToken, baseUrl }) => action$.pipe((0, redux_observable_1.ofType)(ActionTypes.CREATE_REPORT_REQUEST), (0, operators_1.mergeMap)((request) => {
    const _a = request.payload, { type } = _a, body = __rest(_a, ["type"]);
    const createRequest = () => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/reports${getPath(type)}`,
        body
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.createReportSuccess(), Actions.fetchReportListRequest(body.customerId, type))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.createReportFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    return validate(request.payload).fold((e) => (0, rxjs_1.of)(Actions.createReportValidation(ValidationUtils.mapValidationErrors(e))), createRequest);
}));
exports.createReport = createReport;
//# sourceMappingURL=create.js.map